import moment from 'moment';
import ExportJsonExcel from 'js-export-excel';
import { splitNames } from '../../../Utils/Patient';
import { parseName } from '../../../Utils/Names';

class AppointmentOpportunityRes0256ToExcel {
    exportExcel(data) {
        console.log(data);
        let option = {};  // la opción representa el archivo de Excel
        let sheetData = [];

        for(let i=0;i<data.length; i++) {
            let boxesData = this.saveBoxes(data[i]);
            sheetData.push(boxesData);
        }

        console.log(sheetData);
        
        option.fileName = 'Oportunidad de Cita Res 0256';  // nombre del archivo Excel (Maximo 31 caracteres)
        option.datas = [
            {
                sheetName: 'Oportunidad de Cita Res 0256',  // nombre de la página de hoja en el archivo de Excel
                sheetFilter: this.getFilterAndHeader(),
                sheetHeader: this.getFilterAndHeader(),
                //columnWidths: [20, 20],
                sheetData: sheetData  // Fuente de datos en archivo Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel
        
    }

    getFilterAndHeader() {
        let headers = [
            "TIPO DOCUMENTO",
            /* "VALIDACION ID DE USUARIO", */
            "NÚMERO DE DOCUMENTO",
            "FECHA NACIMIENTO",
            /* "VALIDACION FECHA DE NACIMIENTO", */
            "SEXO",
            /* "VALIDACION SEXO", */
            "PRIMER APELLIDO",
            "SEGUNDO APELLIDO",
            "PRIMER NOMBRE",
            "SEGUNDO NOMBRE",
            "CODIGO DE LA EAPB",
            /* "VALIDACION CODIGO DE LA EAPB", */
            "CUP",
            /* "VALIDACION TIPO DE CITA", */
            "FECHA DE SOLICITUD DE LA CITA",
            /* "VALIDACION FECHA DE SOLICITUD DE LA CITA", */
            "CITA ASIGNADA (SI/NO)",
            "FECHA ASIGNACION DE LA CITA",
            /* "VALIDACION FECHA DE ASIGNACION DE LA CITA", */
            "FECHA SOLICITADA POR EL USUARIO",
            /* "VALIDACION FECHA SOLICITADA POR EL USUARIO" */
        ]
        return headers;
    }

    saveBoxes(dataAppointment) {
        let patientNameSplitted = splitNames(dataAppointment.nombres);
        /* let completeName = dataAppointment.nombres + " " + dataAppointment.apellido1 + " " + dataAppointment.apellido2;
        let patientNameSplitted = parseName(completeName); */

        console.log(patientNameSplitted);

        let dataAppointmentBoxes = {
            "TIPO DOCUMENTO": dataAppointment.tipo_documento,
            /* "VALIDACION ID DE USUARIO": dataAppointment.validacion_usuario, */
            "NÚMERO DE DOCUMENTO": dataAppointment.num_documento,
            "FECHA NACIMIENTO": moment(new Date(dataAppointment.fec_nacimiento)).format('YYYY/MM/DD'),
            /* "VALIDACION FECHA DE NACIMIENTO": dataAppointment.validacion_fec_nacimiento, */
            "SEXO": dataAppointment.sexo,
            /* "VALIDACION SEXO": dataAppointment.validacion_sexo, */
            "PRIMER APELLIDO": dataAppointment.apellido1,
            "SEGUNDO APELLIDO": dataAppointment.apellido2,
            "PRIMER NOMBRE": patientNameSplitted[0],
            "SEGUNDO NOMBRE": patientNameSplitted[1],
            "NOMBRE": dataAppointment.nombres,
            "CODIGO DE LA EAPB": dataAppointment.eapb != null ? dataAppointment.eapb : "NA PACIENTES PARTICULARES, PREPAGADAS, ARLS,PLANES COMPLEMENTARIOS",
            /* "VALIDACION CODIGO DE LA EAPB": dataAppointment.validacion_eapb, */
            "CUP": dataAppointment.cup,
            /* "VALIDACION TIPO DE CITA": dataAppointment.validacion_cup, */
            "FECHA DE SOLICITUD DE LA CITA": moment(new Date(dataAppointment.fecha_solicitud)).format('YYYY/MM/DD') ,
            /* "VALIDACION FECHA DE SOLICITUD DE LA CITA": dataAppointment.validacion_fecha_solicitud, */
            "CITA ASIGNADA (SI/NO)": dataAppointment.cita_asignada,
            "FECHA ASIGNACION DE LA CITA": moment(new Date(dataAppointment.fecha_asignacion)).format('YYYY/MM/DD'),
            /* "VALIDACION FECHA DE ASIGNACION DE LA CITA": dataAppointment.validacion_fecha_asignacion, */
            "FECHA SOLICITADA POR EL USUARIO": moment(new Date(dataAppointment.fecha_deseada)).format('YYYY/MM/DD'),
            /* "VALIDACION FECHA SOLICITADA POR EL USUARIO" : dataAppointment.validacion_fecha_deseada, */
        }
        return dataAppointmentBoxes;
    }

    splitPatientName(name)
    {
        var arrName = name.split(" ");
        return arrName;
    }

}

export default new AppointmentOpportunityRes0256ToExcel();